import { create } from "zustand";

// Music playback state (ephemeral — not persisted)
// audioElements registry allows play/pause to be called directly in user gesture call stack (required by iOS)
export const useMusicPlaybackStore = create((set, get) => ({
  playingModels: {},
  audioElements: {},
  isPlaying: (modelId) => !!get().playingModels[modelId],
  registerAudio: (modelId, audioEl) =>
    set((s) => ({
      audioElements: { ...s.audioElements, [modelId]: audioEl },
    })),
  unregisterAudio: (modelId) =>
    set((s) => {
      const { [modelId]: _, ...rest } = s.audioElements;
      return { audioElements: rest };
    }),
  setPlaying: (modelId, playing) =>
    set((s) => ({
      playingModels: { ...s.playingModels, [modelId]: playing },
    })),
  togglePlaying: (modelId) => {
    const state = get();
    const nowPlaying = !state.playingModels[modelId];
    const audioEl = state.audioElements[modelId];

    if (nowPlaying) {
      // Pause all other audio first — only one MP3 plays at a time
      Object.entries(state.audioElements).forEach(([id, el]) => {
        if (id !== modelId) el.pause();
      });
      if (audioEl) audioEl.play().catch(() => {});
      // Set only this model as playing
      const fresh = {};
      Object.keys(state.playingModels).forEach((id) => { fresh[id] = false; });
      fresh[modelId] = true;
      set({ playingModels: fresh });
    } else {
      if (audioEl) audioEl.pause();
      set((s) => ({
        playingModels: { ...s.playingModels, [modelId]: false },
      }));
    }
  },
  stopAll: () => {
    const audioEls = get().audioElements;
    Object.values(audioEls).forEach((el) => el.pause());
    set({ playingModels: {} });
  },
}));
